
<div class="page-title">
    <button class="btn link-btn btn-back">
        <i class="app-icon icon icon-chevron-left icon-xl" (click)="redirectTermsAndConditions()"></i>
    </button>
    {{'termsAndConditions.consent.title' | translate}}
</div>

<div class="consent-search-container d-flex align-items-center p-2 col-xxl-6 mx-auto my-4">
    <i class="app-icon icon icon-search icon-xl ms-3"></i>
    <div class="search-input-wrap">
        <kendo-textbox
            type="text"
            [clearButton]='true'
            [placeholder]="'termsAndConditions.consent.searchPlaceholder' | translate"
            (valueChange)="filterConsentList($event)">
        </kendo-textbox>
    </div>
</div>

<div class="d-flex flex-column align-items-center my-5 my-lg-0" *ngIf="!hasNoData">
    <no-records-placeholder
        [showNoRecordsHeader]="true"
        [noRecordsSubheaderText1] ="subText"
        [noRecordsSubheaderText2] ="subText"
        [noRecordsSubheaderText3] ="subText"
    ></no-records-placeholder>
</div>

<terms-and-conditions-consent-list-view
    *ngIf="(cookieMessageConsents?.length > 0)"
    [cookies]="cookieMessageConsents"
    [props] ="props"
>
</terms-and-conditions-consent-list-view>

